<template>
    <teleport to="body">
        <div class="modal-content">
            <h5 class="modal-title mb-3">Add New Contact</h5>
            <input
                v-model="name"
                placeholder="Name"
                class="contact-field border-radius-lg w-100"
                :disabled="isLoadingAddContact"
            />
            <small v-if="name.trim().length === 0" class="text-danger mx-3">Name is required.</small>
            <input
                v-model="email"
                placeholder="Email"
                class="contact-field border-radius-lg mt-3 w-100"
                :disabled="isLoadingAddContact"
            />
            <small v-if="email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)" class="text-danger mx-3">
                Enter a valid email.
            </small>
            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-outline-shareguard me-2" :disabled="isLoadingAddContact" @click="closeAddContactModal">Cancel</button>
                <button class="btn btn-shareguard" :disabled="!isFormValid || isLoadingAddContact" @click="addContactClick">
                    {{ isLoadingAddContact ? "Adding..." : "Save" }}
                </button>
            </div>
        </div>
    </teleport>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'AddContactModal',
    emits: ['closeAddContactModal'],
    data() {
        return {
            name: '',
            email: ''
        }
    },
    computed: {
        ...mapGetters("contacts", ["isLoadingAddContact"]),
        isFormValid() {
            const nameValid = this.name.trim().length > 0;
            const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
            return nameValid && emailValid;
        }
    },
    created() {
        this.$store.commit('setOverlay', true);
    },
    beforeUnmount() {
        this.$store.commit('setOverlay', false);
    },
    methods: {
        ...mapActions("contacts", ["addContactAction", "fetchContactList"]),
        ...mapActions("snackbar", ["showSnackbar"]),
        async addContactClick() {
            if (this.isFormValid) {
                try {
                    await this.addContactAction({ name: this.name, email: this.email });
                    this.closeAddContactModal();
                } catch (error) {
                    console.error("Error adding contact:", error);
                }
            }
        },
        closeAddContactModal() {
            this.fetchContactList();
            this.$emit('closeAddContactModal');
        }
    }
}
</script>

<style scoped>
.modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 2rem;
    border-radius: 0.5rem;
    min-width: 300px;
    max-width: 500px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    z-index: $zindex-modal-content;
}

@media (max-width: 576px) {
    .modal-content {
        max-width: 87.5%;
    }
}

.contact-field {
    border: 1px solid rgb(229, 231, 235);
    padding: 0.5rem 1rem;
    height: 38px;
}
</style>

